import styled, { createGlobalStyle } from 'styled-components';
import {
  SYS_SPACE_FIXED_25,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_350,
  SYS_FONT_SIZES_RELATIVE_75,
  SYS_BORDER_RADIUS_SM,
} from '@oneaudi/unified-web-common';
import { getResponsiveSpacing, createMediaQuery } from '../../utils';

export const ListItem = styled.li`
  list-style-type: none;
`;

export const LinkCard = styled.a<{ showIcon: boolean }>`
  box-sizing: border-box;
  border: 1px solid
    ${(props) =>
      props?.theme?.sys?.color?.outline?.[200] ||
      props?.theme?.sys?.color?.outline?.default ||
      '#d9d9d9'} !important;
  background-color: ${(props) =>
    props?.theme?.sys?.color?.canvas?.[200] || props?.theme?.sys?.color?.canvas?.default};
  display: flex;
  align-items: center;
  flex-grow: 1;
  height: 72px;
  ${(props) =>
    createMediaQuery({
      padding: {
        xs: `${getResponsiveSpacing('s')(props) || '8px'} ${getResponsiveSpacing('m')(props) || '16px'} !important`,
        m: `${getResponsiveSpacing('xl')(props) || '24px'} ${getResponsiveSpacing('m')(props) || '16px'} !important`,
        l: `${getResponsiveSpacing('xl')(props) || '24px'} ${getResponsiveSpacing('xl')(props) || '24px'} !important`,
        xl: '28px 28px !important',
      },
      height: {
        m: '98px',
      },
    })}

  p {
    color: ${(props) =>
      props?.theme?.sys?.color?.onSurface?.[200] || props?.theme?.sys?.color?.onSurface?.default};
    flex: 1;
    text-align: left;
    word-wrap: break-word;
    display: inline-block;
    vertical-align: middle;
    ${(props) =>
      createMediaQuery({
        padding: {
          xs: `0 ${getResponsiveSpacing('m')(props) || '16px'} 0 0`,
          l: props.showIcon
            ? `0px ${getResponsiveSpacing('m')(props) || '16px'} 0px ${getResponsiveSpacing('m')(props) || '16px'}`
            : `0px ${getResponsiveSpacing('m')(props) || '16px'} 0px 0px`,
        },
      })}
  }
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

export const IconContainer = styled.div<{ showIcon: boolean }>`
  overflow: visible;
  width: 24px;
  height: 24px;
  pointer-events: none;
  ${(props) =>
    createMediaQuery({
      display: {
        xs: 'none',
        l: props.showIcon ? 'block' : 'none',
      },
    })}
`;

export const LinkIconContainer = styled.div`
  overflow: visible;
  width: 24px;
  height: 24px;
`;

export const AlphaTileGlobalStyles = createGlobalStyle<{ showIcon: boolean }>`
  .alpha-tile-spacing {
    padding: ${SYS_SPACE_FIXED_350} ${SYS_SPACE_FIXED_200};
    gap: ${SYS_SPACE_FIXED_25};
    border-radius: ${SYS_BORDER_RADIUS_SM};

    p {
      flex: 1;
      padding-right: ${SYS_SPACE_FIXED_200};
      font-size: ${SYS_FONT_SIZES_RELATIVE_75};
      
      @media (min-width: 1024px) {
        padding-left: ${(props) => (props.showIcon ? SYS_SPACE_FIXED_200 : '0')};
      }
    }
  }
`;

export const SingleLinkStoryWrapper = styled.div`
  box-sizing: border-box;
  padding: 10px;
  ${createMediaQuery({
    width: {
      xs: '100%',
      m: '218.6px',
      l: '290.6px',
      xl: '400px',
    },
  })}
`;
